document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('deferred-media').forEach(el => {
      const observer = new MutationObserver(() => {
        const video = el.querySelector('.media-video');
        const volumeContainer = el.querySelector('.media-video__volume-container');
        const volumeSlider = el.querySelector('.media-video__volume');
        const volumeIcon = el.querySelector('.volume-icon');
        const scrub = el.querySelector('.media-video__scrub');

        if (!video) return;

        observer.disconnect();
        video.removeAttribute('controls');
        video.muted = false;

        if (!video.dataset.clickListenerAttached) {
          video.addEventListener('click', () => {
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          });
          video.dataset.clickListenerAttached = "true";
        }

        if (volumeIcon && !volumeIcon.dataset.listenerAttached) {
          volumeIcon.addEventListener('click', () => {
            volumeContainer.classList.toggle('active');
          });
          volumeIcon.dataset.listenerAttached = "true";
        }

        if (volumeSlider && !volumeSlider.dataset.listenerAttached) {
          volumeSlider.addEventListener('input', () => {
            video.volume = volumeSlider.value;
          });
          volumeSlider.dataset.listenerAttached = "true";
        }

        if (scrub && !scrub.dataset.listenerAttached) {
          scrub.addEventListener('input', () => {
            video.currentTime = (scrub.value / 100) * video.duration;
          });
          scrub.dataset.listenerAttached = "true";
        }

        if (!video.dataset.timeUpdateAttached) {
          video.addEventListener('timeupdate', () => {
            scrub.value = (video.currentTime / video.duration) * 100 || 0;
          });
          video.dataset.timeUpdateAttached = "true";
        }
      });

      observer.observe(el, { childList: true, subtree: true });
    });
  });